// i18n area 'tasks' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/tasks.sk-SK.meta.json.
import type { enUS } from './tasks'

export const skSK: typeof enUS = {
  macrotasks: {
    title: 'Makroúlohy',
    subtitle: 'Zložené operácie — možno v nich pokračovať od zlyhaného kroku alebo ich prerušiť',
    colType: 'Typ',
    colTarget: 'Objekt',
    colPhase: 'Fáza',
    colSteps: 'Kroky',
    empty: 'Žiadne makroúlohy',
    detail: 'Podrobnosti',
    failedAt: 'zlyhala pri kroku',
    resume: 'Skúsiť znova od zlyhaného kroku',
    abort: 'Prerušiť všetko',
    cancel: 'Zrušiť',
    actionError: 'Akcia bola odmietnutá'
  },
  tasks: {
    title: 'Úlohy',
    searchPlaceholder: 'Hľadať podľa typu alebo targetu',
    type: 'Typ',
    target: 'Target',
    phaseLabel: 'Fáza',
    progress: 'Priebeh',
    started: 'Začatá',
    finished: 'Ukončená',
    node: 'Uzol',
    empty: 'Žiadne úlohy',
    loadError: 'Úlohy sa nepodarilo načítať — je backend TVirt dostupný?',
    limboHint: 'Uzol \'{node}\' je nedostupný od {time} — úloha drží write lease na svojom targete, kým sa uzol nevráti alebo nebude atestovaný ako vypnutý',
    nodeAttested: 'Uzol atestovaný ako vypnutý',
    phase: {
      queued: 'Vo fronte',
      running: 'Beží',
      succeeded: 'Dokončená',
      failed: 'Zlyhala',
      cancelled: 'Zrušená',
      'failed-at-step': 'Zlyhala pri kroku',
      aborted: 'Prerušená'
    },
    dropdown: {
      tooltip: 'Prebiehajúce úlohy',
      title: 'Prebiehajúce úlohy',
      empty: 'Žiadne prebiehajúce úlohy',
      viewAll: 'Zobraziť všetky úlohy'
    },
    detail: {
      open: 'Podrobnosti',
      scope: 'Scope',
      message: 'Správa',
      params: 'Parametre',
      result: 'Výsledok',
      errorTitle: 'Chyba',
      steps: 'Kroky',
      failedAt: 'zlyhala pri kroku',
      superseded: 'nahradená',

      // Dialog standard (round #156): il posto del figlio nel piano del padre,
      // il padre stesso (apribile in-place) e il passo colpevole.
      step: 'Krok',
      parent: 'Nadradená úloha',
      failedStep: 'Zlyhaný krok',
      log: 'Log',
      logEmpty: 'Zatiaľ žiadne riadky logu',
      close: 'Zavrieť'
    },
    actions: {
      cancel: 'Zrušiť',
      resume: 'Skúsiť znova od zlyhaného kroku',
      abort: 'Prerušiť všetko (vráti späť dokončené kroky)',
      refused: 'Akcia bola odmietnutá'
    }
  },
  events: {
    loadError: 'Denník sa nepodarilo načítať — je backend TVirt dostupný?',
    title: 'Udalosti',
    subtitle: 'Historická pamäť klastra: dokonané skutočnosti, od najnovších',
    filterSeverity: 'Závažnosť',
    filterCategory: 'Kategória',
    filterAll: 'Všetky',
    searchLabel: 'Hľadať',
    searchPlaceholder: 'Hľadať v celom denníku',
    subjectFilter: 'Udalosti {subject} — zobraziť všetko',
    colAt: 'Kedy',
    colSeverity: 'Závažnosť',
    colType: 'Typ',
    colSubject: 'Predmet',
    colActor: 'Kto',
    colNode: 'Node',
    colMessage: 'Správa',
    empty: 'Žiadne udalosti',
    loadMore: 'Načítať ďalšie',
    actorSystem: 'systém',
    detailScope: 'Scope',
    detailTask: 'Task',
    detailId: 'ID udalosti',
    taskCollectedHint: 'Task má kratšiu retenciu: po zozbieraní odkaz už neodpovedá',
    severity: {
      info: 'Informácia',
      warning: 'Varovanie',
      error: 'Chyba',
      critical: 'Kritické'
    },
    category: {
      lifecycle: 'Životný cyklus',
      config: 'Konfigurácia',
      availability: 'Dostupnosť',
      security: 'Bezpečnosť'
    },
    type: {
      haNetsvcFailedOver: 'Failover sieťovej služby',
      haNetsvcNoCandidate: 'Sieťová služba bez kandidátskeho uzla',
      haNetsvcReaped: 'Lokálna inštancia zožatá pri návrate',
      netsvcFloatipMoved: 'Plávajúca IP sa presunula na iného držiteľa',
      netsvcFloatipNoHolder: 'Plávajúca IP bez zdravého cieľa',
      haAppFailedOver: 'Failover inštancie App',
      haAppNoCandidate: 'Inštancia App bez kandidátskeho uzla',
      haAppStorageLocalSkip: 'Inštancia App neprenesená: trvalé dáta sú lokálne na mŕtvom uzle',
      haAppReaped: 'Lokálny pod inštancie App zožatý pri návrate'
    }
  },
  audit: {
    loadError: 'Register auditu sa nepodarilo načítať — je backend TVirt dostupný?',
    title: 'Audit',
    subtitle: 'Kto čo urobil, kedy a nad akým objektom — pokusy o úkon, vrátane odmietnutých',
    filterOutcome: 'Výsledok',
    filterAll: 'Všetky',
    filterSudo: 'Len povýšené úkony',
    colAt: 'Kedy',
    colActor: 'Kto',
    colAction: 'Akcia',
    colTarget: 'Objekt',
    colOutcome: 'Výsledok',
    colNode: 'Node',
    empty: 'Žiadne zaznamenané úkony',
    loadMore: 'Načítať ďalšie',
    sudoBadge: 'sudo',
    tokenBadge: 'app token',
    detailScope: 'Scope',
    detailPath: 'Cesta',
    detailProblem: 'Dôvod',
    detailTask: 'Task',
    detailClientIp: 'Odkiaľ',
    detailId: 'ID záznamu',
    detailSession: 'Relácia',
    taskHint: 'Výsledok prijatého úkonu žije v denníku udalostí, pod rovnakým id tasku',
    outcome: {
      succeeded: 'Vykonané',
      accepted: 'Prijaté',
      denied: 'Odopreté',
      rejected: 'Odmietnuté',
      failed: 'Zlyhalo'
    }
  },
  notifications: {
    loadError: 'Oznámenia sa nepodarilo načítať — je backend TVirt dostupný?',
    actionError: 'Akcia bola odmietnutá',
    title: 'Oznámenia',
    subtitle: 'Ciele, do ktorých fakty denníka opúšťajú klaster',
    rulesTitle: 'Pravidlá',
    rulesSubtitle: 'Ktoré fakty odchádzajú a kam',
    deliveriesTitle: 'Doručenia',
    deliveriesSubtitle: 'Výsledok každého oznámenia, s dôvodom keď zlyhá',
    colName: 'Názov',
    colKind: 'Typ',
    colWhere: 'Kam',
    colScope: 'Scope',
    colSeverity: 'Závažnosť',
    colMatch: 'Filter',
    colTargets: 'Cieľ',
    colAt: 'Kedy',
    colState: 'Stav',
    colEvent: 'Udalosť',
    colAttempts: 'Pokusy',
    colOutcome: 'Výsledok',
    empty: 'Žiadne riadky',
    matchAll: 'všetky fakty',
    test: 'Otestovať',
    testOk: 'Testovacie oznámenie doručené do {target}',
    testFailed: 'Test do {target} zlyhal: {reason}',
    retry: 'Vrátiť do frontu',
    retried: 'Doručenie vrátené do frontu',
    grouped: 'a ďalších {count} opakovaní',
    state: {
      failed: 'Zlyhalo',
      pending: 'Vo fronte',
      sending: 'Odosiela sa',
      sent: 'Odoslané'
    },
    tabTargets: 'Cíle',
    tabRules: 'Pravidlá',
    tabDeliveries: 'Doručenia',
    targetCreateTitle: 'Nový cieľ',
    ruleCreateTitle: 'Nové pravidlo',
    nameHint: 'Malé písmená, číslice a spojovníky; jedinečné v rámci scope',
    kindImmutableHint: 'Nemenné: zmena typu znamená vytvoriť iný cieľ',
    kindSmtp: 'Pošta (SMTP)',
    kindWebhook: 'Webhook',
    enabled: 'Stav',
    enabledOn: 'Aktívny',
    enabledOff: 'Pozastavený',
    smtpHost: 'SMTP server',
    smtpPort: 'Port',
    smtpPortHint: 'Obvykle: 25 bez TLS, 587 so starttls, 465 s tls',
    smtpSecurity: 'Zabezpečenie',
    smtpFrom: 'Odosielateľ',
    smtpTo: 'Príjemcovia',
    smtpToHint: 'Jedna alebo viac adries oddelených čiarkou',
    webhookUrl: 'URL',
    payload: 'Obsah',
    payloadHint: 'Pri minimal správa a údaje udalosti neopustia cluster',
    credential: 'Prihlasovací údaj',
    credentialNone: 'Žiadny',
    credentialHintSmtp: 'Konto relay z keystore; žiadny znamená anonymné SMTP',
    credentialHintWebhook: 'Podpisové tajomstvo z keystore; bez podpisu sa za cluster môže vydávať každý, kto pozná URL',
    minSeverityHint: 'Prah, nie množina: od tejto závažnosti nahor',
    categories: 'Kategórie',
    categoriesHint: 'Prázdne = všetky',
    types: 'Typy udalostí',
    typesHint: 'Oddelené čiarkou; prázdne = všetky. Neznámy typ je odmietnutý',
    targetsHint: 'Aspoň jeden; musia byť v scope pravidla alebo v jeho predkovi',
    recursiveOn: 'Aj podriadené scope',
    recursiveOff: 'Iba tento scope',
    recursiveHint: 'Zdroje žijú v listoch: bez potomkov pravidlo na koreni oznámi takmer nič',
    repeatWindow: 'Okno zoskupenia (s)',
    repeatWindowHint: 'V okne opakovania neposielajú poštu: počítajú sa pri prvom. 0 vypína',
    targetInUseError: 'Cieľ {name} ešte používa pravidlo'
  }
}
